import { FaLaptopCode, FaCube, FaCog } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaLaptopCode />, // Laptop Code icon
    title: 'Digital Printing',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur possimus assumenda dolores odit voluptatibus.',
  },
  {
    id: 2,
    icon: <FaCube />, // Cube icon
    title: '3D Printing',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur possimus assumenda dolores odit voluptatibus.',
  },
  {
    id: 3,
    icon: <FaCog />, // Cog icon
    title: 'Offset Printing',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur possimus assumenda dolores odit voluptatibus.',
  },
];

export default features;